import styled from "styled-components";

const MultilineText = styled.div`
  white-space: break-spaces;
`;

export default MultilineText;
